import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Phone, Calendar, MessageCircle } from 'lucide-react';

interface BlogCTAProps {
  location?: string;
}

const BlogCTA: React.FC<BlogCTAProps> = ({ location = 'Eastern NC' }) => {
  return (
    <Card className="w-full max-w-2xl md:max-w-3xl mx-auto lg:mx-0 lg:w-full bg-gradient-to-r from-brand-charcoal-gray to-gray-800 text-white border-0 mt-12 overflow-hidden">
      <CardContent className="p-8 md:p-12 text-center">
        <h2 className="text-3xl font-bold mb-4 text-brand-trophy-gold">
          Ready to Get Started?
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto text-gray-200">
          Don't wait for roof problems to get worse. Get expert roofing solutions for your {location} property today.
        </p>
        
        <div className="grid md:grid-cols-3 gap-4 mb-8 place-items-center">
          <div className="text-center">
            <div className="w-12 h-12 bg-brand-safety-orange/20 rounded-full flex items-center justify-center mx-auto mb-2">
              <Phone className="h-6 w-6 text-brand-safety-orange" />
            </div>
            <h3 className="font-semibold mb-1">Call Now</h3>
            <p className="text-sm text-gray-300">24/7 Emergency Service</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 bg-brand-trophy-gold/20 rounded-full flex items-center justify-center mx-auto mb-2">
              <Calendar className="h-6 w-6 text-brand-trophy-gold" />
            </div>
            <h3 className="font-semibold mb-1">Free Inspection</h3>
            <p className="text-sm text-gray-300">No obligation assessment</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 bg-brand-safety-orange/20 rounded-full flex items-center justify-center mx-auto mb-2">
              <MessageCircle className="h-6 w-6 text-brand-safety-orange" />
            </div>
            <h3 className="font-semibold mb-1">Expert Advice</h3>
            <p className="text-sm text-gray-300">Professional consultation</p>
          </div>
        </div>
        
        <div className="flex flex-col gap-3 justify-center items-stretch w-full max-w-md mx-auto">
          <Link to="/book-inspection" className="w-full min-w-0 block">
            <Button className="w-full bg-brand-safety-orange hover:bg-brand-safety-orange/90 text-white font-semibold px-3 md:px-4 text-sm md:text-base whitespace-normal break-words leading-snug">
              <Calendar className="mr-2 h-4 w-4" />
              Schedule Free Inspection
            </Button>
          </Link>
          <Button
            variant="outline"
            className="w-full min-w-0 border-brand-trophy-gold text-brand-trophy-gold hover:bg-brand-trophy-gold/10 px-3 md:px-4 text-sm md:text-base whitespace-normal break-words leading-snug"
          >
            <Phone className="mr-2 h-4 w-4" />
            Call (252) 302-2003
          </Button>
        </div>
        
        <div className="mt-6 text-sm text-gray-300">
          <p>✓ Licensed & Insured • ✓ Local Family Business • ✓ A+ BBB Rating</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default BlogCTA;